import * as Yup from 'yup';

// Definindo o esquema de validação com Yup
export const validationSchema = Yup.object().shape({
    nameTag: Yup.string().required('Nome é obrigatório'),
    // tag: Yup.string().required('Tag é obrigatório'),
    // responsive: Yup.string().required('Responsivo é obrigatório'),
});